import { useState } from 'react';
import { GripVertical, Eye, EyeOff } from 'lucide-react';
import type { SiteConfig, SectionMeta } from '../../../siteContentTypes.ts';

const LABELS: Record<SectionMeta['key'], string> = {
  trustLogos: 'Logos partenaires',
  statistics: 'Chiffres',
  howItWorks: 'Comment ça marche',
  video: 'Vidéo',
  extrasSection: 'Section Extras',
  restaurantsSection: 'Section Restaurateurs',
  matching: 'Matching',
  testimonials: 'Témoignages',
  beforeAfter: 'Avant / après',
  finalCta: 'CTA final',
  faq: 'FAQ',
};

export function SectionsOrderSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const [dragIndex, setDragIndex] = useState<number | null>(null);

  function move(from: number, to: number) {
    if (from === to) return;
    const next = config.sections.slice();
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    update({ sections: next });
  }

  function setVisible(index: number, visible: boolean) {
    const next = config.sections.slice();
    next[index] = { ...next[index], visible };
    update({ sections: next });
  }

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 8 }}>Sections de la page</h2>
      <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 20 }}>
        Glissez-déposez pour réordonner. Le header, le hero et le footer sont toujours affichés et ne figurent pas dans cette liste.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {config.sections.map((section, i) => (
          <div
            key={section.key}
            draggable
            onDragStart={() => setDragIndex(i)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => {
              if (dragIndex !== null) move(dragIndex, i);
              setDragIndex(null);
            }}
            className="card"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '12px 16px',
              opacity: dragIndex === i ? 0.5 : 1,
              cursor: 'grab',
            }}
          >
            <GripVertical size={16} color="var(--text-tertiary)" />
            <span style={{ flex: 1, fontWeight: 700, fontSize: 14 }}>{LABELS[section.key]}</span>
            <button
              type="button"
              className="btn btn-secondary"
              style={{ width: 'auto', padding: '7px 14px', fontSize: 12.5 }}
              onClick={() => setVisible(i, !section.visible)}
            >
              {section.visible ? <Eye size={14} /> : <EyeOff size={14} />}
              {section.visible ? 'Visible' : 'Masquée'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
